module.exports = __webpack_public_path__ + "static/img/imagen-material-1.21ad4b04.png";